<template>
<div>
  <div class="title">Trading</div>
  <TokenTable title="Trading"></TokenTable>
</div>
</template>

<script>
import TokenTable from './ctrl/TokenTable';


export default {
  name: 'Staking',
  components: {TokenTable}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trading.vue